const websiteURL =
  process.env.NODE_ENV === "production"
    ? "https://flowrota.com"
    : `http://${window.location.hostname}:3000`;

export default websiteURL;
